"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkStrictMode = exports.schemaCxtHasRules = exports.subschemaCode = exports.validateFunctionCode = void 0;

var boolSchema_1 = require("./boolSchema");

var dataType_1 = require("./dataType");

var iterate_1 = require("./iterate");

var codegen_1 = require("../codegen");

var names_1 = require("../names");

var resolve_1 = require("../resolve");

var util_1 = require("../util"); // schema compilation - generates validation function, subschemaCode (below) is used for subschemas


function validateFunctionCode(it) {
  if (isSchemaObj(it)) {
    checkKeywords(it);

    if (schemaCxtHasRules(it)) {
      topSchemaObjCode(it);
      return;
    }
  }

  validateFunction(it, function () {
    return boolSchema_1.topBoolOrEmptySchema(it);
  });
}

exports.validateFunctionCode = validateFunctionCode;

function validateFunction(_ref, body) {
  var gen = _ref.gen,
      validateName = _ref.validateName,
      schema = _ref.schema,
      schemaEnv = _ref.schemaEnv,
      opts = _ref.opts;

  if (opts.code.es5) {
    gen.func(validateName, codegen_1._(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ", ", ""])), names_1.default.data, names_1.default.valCxt), schemaEnv.$async, function () {
      gen.code(codegen_1._(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\"use strict\"; ", ""])), funcSourceUrl(schema, opts)));
      destructureValCxtES5(gen, opts);
      gen.code(body);
    });
  } else {
    gen.func(validateName, codegen_1._(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ", ", ""])), names_1.default.data, destructureValCxt(opts)), schemaEnv.$async, function () {
      return gen.code(funcSourceUrl(schema, opts)).code(body);
    });
  }
}

function destructureValCxt(opts) {
  return codegen_1._(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["{", "=\"\", ", ", ", ", ", "=", "", "}={}"])), names_1.default.dataPath, names_1.default.parentData, names_1.default.parentDataProperty, names_1.default.rootData, names_1.default.data, opts.dynamicRef ? codegen_1._(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([", ", "={}"])), names_1.default.dynamicAnchors) : codegen_1.nil);
}

function destructureValCxtES5(gen, opts) {
  gen.if(names_1.default.valCxt, function () {
    gen.var(names_1.default.dataPath, codegen_1._(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ".", ""])), names_1.default.valCxt, names_1.default.dataPath));
    gen.var(names_1.default.parentData, codegen_1._(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", ".", ""])), names_1.default.valCxt, names_1.default.parentData));
    gen.var(names_1.default.parentDataProperty, codegen_1._(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["", ".", ""])), names_1.default.valCxt, names_1.default.parentDataProperty));
    gen.var(names_1.default.rootData, codegen_1._(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["", ".", ""])), names_1.default.valCxt, names_1.default.rootData));
    if (opts.dynamicRef) gen.var(names_1.default.dynamicAnchors, codegen_1._(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["", ".", ""])), names_1.default.valCxt, names_1.default.dynamicAnchors));
  }, function () {
    gen.var(names_1.default.dataPath, codegen_1._(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\"\""]))));
    gen.var(names_1.default.parentData, codegen_1._(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["undefined"]))));
    gen.var(names_1.default.parentDataProperty, codegen_1._(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["undefined"]))));
    gen.var(names_1.default.rootData, names_1.default.data);
    if (opts.dynamicRef) gen.var(names_1.default.dynamicAnchors, codegen_1._(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["{}"]))));
  });
}

function topSchemaObjCode(it) {
  var schema = it.schema,
      opts = it.opts,
      gen = it.gen;
  validateFunction(it, function () {
    if (opts.$comment && schema.$comment) commentKeyword(it);
    checkNoDefault(it);
    gen.let(names_1.default.vErrors, null);
    gen.let(names_1.default.errors, 0);
    if (opts.unevaluated) resetEvaluated(it);
    typeAndKeywords(it);
    returnResults(it);
  });
  return;
}

function resetEvaluated(it) {
  // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
  var gen = it.gen,
      validateName = it.validateName;
  it.evaluated = gen.const("evaluated", codegen_1._(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["", ".evaluated"])), validateName));
  gen.if(codegen_1._(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["", ".dynamicProps"])), it.evaluated), function () {
    return gen.assign(codegen_1._(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["", ".props"])), it.evaluated), codegen_1._(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["undefined"]))));
  });
  gen.if(codegen_1._(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["", ".dynamicItems"])), it.evaluated), function () {
    return gen.assign(codegen_1._(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["", ".items"])), it.evaluated), codegen_1._(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["undefined"]))));
  });
}

function funcSourceUrl(schema, opts) {
  return typeof schema == "object" && schema.$id && (opts.code.source || opts.code.process) ? codegen_1._(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["/*# sourceURL=", " */"])), schema.$id) : codegen_1.nil;
} // schema compilation - this function is used recursively to generate code for sub-schemas


function subschemaCode(it, valid) {
  if (isSchemaObj(it)) {
    checkKeywords(it);

    if (schemaCxtHasRules(it)) {
      subSchemaObjCode(it, valid);
      return;
    }
  }

  boolSchema_1.boolOrEmptySchema(it, valid);
}

exports.subschemaCode = subschemaCode;

function schemaCxtHasRules(_ref2) {
  var schema = _ref2.schema,
      self = _ref2.self;
  if (typeof schema == "boolean") return !schema;

  for (var key in schema) {
    if (self.RULES.all[key]) return true;
  }

  return false;
}

exports.schemaCxtHasRules = schemaCxtHasRules;

function isSchemaObj(it) {
  return typeof it.schema != "boolean";
}

function subSchemaObjCode(it, valid) {
  var schema = it.schema,
      gen = it.gen,
      opts = it.opts;
  if (opts.$comment && schema.$comment) commentKeyword(it);
  updateContext(it);
  checkAsync(it);
  var errsCount = gen.const("_errs", names_1.default.errors);
  typeAndKeywords(it, errsCount); // TODO var

  gen.var(valid, codegen_1._(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["", " === ", ""])), errsCount, names_1.default.errors));
}

function checkKeywords(it) {
  util_1.checkUnknownRules(it);
  checkRefsAndKeywords(it);
}

function typeAndKeywords(it, errsCount) {
  if (it.opts.jtd) return iterate_1.schemaKeywords(it, [], false, errsCount);
  var types = dataType_1.getSchemaTypes(it.schema);
  var checkedTypes = dataType_1.coerceAndCheckDataType(it, types);
  iterate_1.schemaKeywords(it, types, !checkedTypes, errsCount);
}

function checkRefsAndKeywords(it) {
  var schema = it.schema,
      errSchemaPath = it.errSchemaPath,
      opts = it.opts,
      self = it.self;

  if (schema.$ref && opts.ignoreKeywordsWithRef && util_1.schemaHasRulesButRef(schema, self.RULES)) {
    self.logger.warn("$ref: keywords ignored in schema at path \"".concat(errSchemaPath, "\""));
  }
}

function checkNoDefault(it) {
  var schema = it.schema,
      opts = it.opts;

  if (schema.default !== undefined && opts.useDefaults && opts.strict) {
    checkStrictMode(it, "default is ignored in the schema root");
  }
}

function updateContext(it) {
  if (it.schema.$id) it.baseId = resolve_1.resolveUrl(it.baseId, it.schema.$id);
}

function checkAsync(it) {
  if (it.schema.$async && !it.schemaEnv.$async) throw new Error("async schema in sync schema");
}

function commentKeyword(_ref3) {
  var gen = _ref3.gen,
      schemaEnv = _ref3.schemaEnv,
      schema = _ref3.schema,
      errSchemaPath = _ref3.errSchemaPath,
      opts = _ref3.opts;
  var msg = schema.$comment;

  if (opts.$comment === true) {
    gen.code(codegen_1._(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["", ".logger.log(", ")"])), names_1.default.self, msg));
  } else if (typeof opts.$comment == "function") {
    var schemaPath = codegen_1.str(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["", "/$comment"])), errSchemaPath);
    var rootName = gen.scopeValue("root", {
      ref: schemaEnv.root
    });
    gen.code(codegen_1._(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["", ".opts.$comment(", ", ", ", ", ".schema)"])), names_1.default.self, msg, schemaPath, rootName));
  }
}

function returnResults(it) {
  var gen = it.gen,
      schemaEnv = it.schemaEnv,
      validateName = it.validateName,
      ValidationError = it.ValidationError,
      opts = it.opts;

  if (schemaEnv.$async) {
    // TODO assign unevaluated
    gen.if(codegen_1._(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["", " === 0"])), names_1.default.errors), function () {
      return gen.return(names_1.default.data);
    }, function () {
      return gen.throw(codegen_1._(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["new ", "(", ")"])), ValidationError, names_1.default.vErrors));
    });
  } else {
    gen.assign(codegen_1._(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["", ".errors"])), validateName), names_1.default.vErrors);
    if (opts.unevaluated) assignEvaluated(it);
    gen.return(codegen_1._(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["", " === 0"])), names_1.default.errors));
  }
}

function assignEvaluated(_ref4) {
  var gen = _ref4.gen,
      evaluated = _ref4.evaluated,
      props = _ref4.props,
      items = _ref4.items;
  if (props instanceof codegen_1.Name) gen.assign(codegen_1._(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["", ".props"])), evaluated), props);
  if (items instanceof codegen_1.Name) gen.assign(codegen_1._(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["", ".items"])), evaluated), items);
}

function checkStrictMode(it, msg) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : it.opts.strict;
  if (!mode) return;
  msg = "strict mode: ".concat(msg);
  if (mode === true) throw new Error(msg);
  it.self.logger.warn(msg);
}

exports.checkStrictMode = checkStrictMode;